<template>
	<el-container class="home_container11">
		<el-container>
				<el-aside>
					<div class="aside_title">
						<img src="../../assets/img/logo.png" alt="">
					</div>
					<el-menu default-active="/Teacher" background-color="#1D1F26" text-color="#FFFFFF" active-text-color="#ED7F26" unique-opened :collapse-transition="false" :router="true" >
						<!-- <el-menu-item index="/home" >
							<i class="el-icon-user-solid"></i>
							<span slot="title">首页</span>
						</el-menu-item> -->
						<el-menu-item index="/Teacher" >
							<i class="el-icon-user-solid"></i>
							<span slot="title">教师管理</span>
						</el-menu-item>
						<el-menu-item index="/xStudent" >
							<i class="el-icon-user-solid"></i>
							<span slot="title">学生管理</span>
						</el-menu-item>
						<el-menu-item index="/keList" >
							<i class="el-icon-user-solid"></i>
							<span slot="title">课程管理</span>
						</el-menu-item>
						<el-menu-item index="/yuanxi" >
							<i class="el-icon-user-solid"></i>
							<span slot="title">院系管理</span>
						</el-menu-item>
						<el-menu-item index="/zuoye" >
							<i class="el-icon-user-solid"></i>
							<span slot="title">课程作业</span>
						</el-menu-item>
						<el-menu-item index="/tiku" >
							<i class="el-icon-user-solid"></i>
							<span slot="title">题库管理</span>
						</el-menu-item>
						<el-menu-item index="/bList" >
							<i class="el-icon-house"></i>
							<span slot="title">班级管理</span>
						</el-menu-item>
						<!-- <el-submenu index="0" >
							<template slot="title"><i :class="icons[1]"></i><span>行为报表分析</span></template>
							<el-menu-item index="/sCourse" >
								<i class="el-icon-house"></i>
								<span slot="title">课程统计</span>
							</el-menu-item>
							<el-menu-item index="/sTeacher" >
								<i class="el-icon-house"></i>
								<span slot="title">教师统计</span>
							</el-menu-item>
							<el-menu-item index="/sStudent">
								<i class="el-icon-house"></i>
								<span slot="title">学生统计</span>
							</el-menu-item>
						</el-submenu> -->
					</el-menu>
				</el-aside>
				<div style="width: calc( 100% - 240px );margin-left: 240px;">
					<el-header>
						<div class="header_nav">
							<div class="header_nav_left">零代码&数字孪生数字智能教学实训平台</div>
							<el-popover placement="bottom" width="100" trigger="hover">
								<div class="info_box">
									<div class="info_item" style="margin: 15px auto;cursor: pointer;text-align: center;font-size: 20px;color: #1A1A1A;"
									@click="getoutlogin()">退出登录</div>
								</div>
								<div class="my"  slot="reference">
									<img src="../../assets/image/mine.png" alt="">
									<!-- <img :src="userinfo.litpic" alt=""> -->
									<div class="my_text">{{userinfo.manager_name}}</div>
								</div>
							</el-popover>
						</div>
					</el-header>
					<el-main>
						<keep-alive>
							<router-view v-if="$route.meta.keepAlive" :key="key"></router-view>
						</keep-alive>
						<router-view v-if="!$route.meta.keepAlive" :key="key"></router-view>
					</el-main>
				</div>
		</el-container>
	</el-container>
</template>
<script>
	import {getInfo} from "../../api/new.js";
	export default {
		data() {
			return {
				icons: {
					1: "el-icon-s-grid",
					2: "el-icon-menu"
				},
				show:true,
				open:false,
				MenuList: [],
				//用户权限组
				userPermissions: [],
				userinfo:''
			};
		},
		computed: {
			key() {
				return this.$route.path;
			}
		},
		mounted() {
			if (location.href.indexOf("#reloaded") == -1) {
				location.href = location.href + "#reloaded";
				location.reload();
			}
			this.getgeInfo()
		},
		created() {

		},
		methods: {
			// 获取个人信息
			getgeInfo() { 
				var _this = this
				getInfo().then((res) => {
					if (res.code == 0) {
						this.userinfo = res.data
						var info = JSON.stringify(res.data)
						localStorage.setItem('userinfo',info)
					} else {
						// location.reload();
						// localStorage.removeItem('userinfo')
						this.$message.error(res.msg);
						// this.$router.replace('/login')
					} 
				})
				.catch((err) => {
					console.log(err);
				});	
			},
			//课程弹窗
			CourseDetail(){
				this.open = true
			},
			//点击跳转首页
			goIndex(){
				this.show = false
			},
			//点击跳转课程列表
			goCourse(){
				this.show = true
			},
			//跳转
			goDetails(e) {
				this.$router.push({
					path: e
				});
			},
			// 退出登录
			getoutlogin() {
				console.log('退出登录')
				this.$confirm('确定退出登录？', "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						localStorage.removeItem('token')
						localStorage.clear()
						this.$router.push({path: "/login"});
					})
					.catch(() => {});
			},
			/**
			 * 判断权限是否存在
			 * @return true 不存在
			 */
			checkPermissions(permis) {
				return !this.userPermissions.indexOf(permis) >= 0;
			}
		},
		created() {}
	};
</script>
<style lang="less" scoped>
	.home_container11 {
		height: 100%;
	}
	.el-header {
		width: calc( 100% - 240px );
		min-width: 1200px;
		background-color: #fff;
		color: #fff;
		height: 80px !important;
		z-index: 9;
		position: absolute;
		top:0;
		right: 0;
		// margin-bottom: 80px;
		.header_nav {
			width: 100%;
			height: 80px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			box-sizing: border-box;
			padding :0 20px;
			.header_nav_left {
				font-size: 22px;
				color:#104099;
				line-height: 24px;
			}
			.header_nav_right {
				display: flex;
				align-items: center;
				.infon {
					cursor: pointer;
					position: relative;
					margin-right: 20px;
					img{
						width: 28px;
					}
					div{
						position: absolute;
						width: 28px;
						height: 14px;
						text-align: center;
						line-height: 14px;
						font-size: 7px;
						color: #fff;
						background: #ED0909;
						border-radius: 8px;
						top:-5px;
						right: -12px;
					}
				}
				.time{
					color: rgba(51, 51, 51, 1);
					font-size: 14px;
					line-height: 14px;
					font-weight: 400;
					padding: 0 16px;
					border-left: 1px solid rgba(238, 238, 238, 1);
					border-right: 1px solid rgba(238, 238, 238, 1);
					margin: 0 14px;
				}
				

			}

		}

	}
	.my{
		display: flex;
		align-items: center;
		cursor: pointer;
		img{
			width: 54px;
			height: 54px;
			border-radius: 50%;
			object-fit: cover;
		}
		.my_text{
			color: #000000;
			font-size: 18px;
			font-weight: 500;
			margin-left: 10px;
		}
	}
	.el-aside {
		background-color: #1D1F26;
		width: 240px !important;
		height: 100%;
		position: absolute;
		z-index: 9;
		.aside_title{
			color: #FFFFFF;
			height: 80px;
			// padding: 0 20px ;
			display: flex;
			align-items: center;
			justify-content: center;
			background-color: #FFFFFF;
		}
		.aside_title img{
			width: 150px;
		}
		.el-menu-item{
			// text-align: center;
			// padding-right: 90px;
			font-size: 16px;
			height: 68px;
		}
		.el-menu {
			border-right: none;
		}
	}
	.el-main {
		background-color: #F5F6F7;
		margin-top: 80px;
	}
	
	.el-submenu .el-menu-item {
		margin-left: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/components/menu/menu.vue